module.exports = __webpack_public_path__ + "static/media/hasher-2.6916e3b1.png";